import axios from 'axios'
import React, { FC, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { URL } from '../../redux/common/url'
import { toast } from 'react-toastify'
import {
  GoogleMap,
  OverlayView,
  useLoadScript,
} from "@react-google-maps/api"


const mapContainerStyle = {
  width: "100%",
  height: "520px"
};

const ViewDetails: FC = () => {

  const { id, status } = useParams();

  const [remark, setRemark] = useState<any>("");
  const [reportData, setReportData] = useState<any>({});
  const [showMap, setShowMap] = useState(false);
  const [gpsHistory, setGpsHistory] = useState<any[]>([])
  const [startPoint, setStartPoint] = useState<any>(null)
  const [endPoint, setEndPoint] = useState<any>(null)
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY!
  });

  useEffect(() => {
    getReports();
  }, []);

  const getReports = async () => {
    try {
      const token = JSON.parse(localStorage.getItem('kt-auth-react-v')!);
      const config = {
        headers: {
          Authorization: 'Bearer ' + token.api_token,
        },
      };

      const query = [`approved=${status}`, `id=${id}`].filter(Boolean).join('&');

      const res = await axios.get(`${URL.API_BASE_URL}${URL.getReports}?${query}`, config);
      const reportsData = res?.data?.data;

      if (reportsData?.data?.length) {
        const booking = reportsData.data[0]

        setReportData(booking)
        setRemark(booking?.remark || '')

        // 🔴 ADDED: extract GPS route data
        if (booking?.booking_route?.route_data) {
          setGpsHistory(booking.booking_route.route_data)
        }

        //  ADDED: START LOCATION
        if (booking?.source_hydrant_center?.latitude) {
          setStartPoint({
            lat: Number(booking.source_hydrant_center.latitude),
            lng: Number(booking.source_hydrant_center.longitude),
          })
        }

        //  ADDED: END LOCATION
        if (booking?.destination?.latitude) {
          setEndPoint({
            lat: Number(booking.destination.latitude),
            lng: Number(booking.destination.longitude),
          })
        }
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message)
    };
  };

  const handleRemarkSubmit = async (id: any, remark: any) => {
    try {
      const token = JSON.parse(localStorage.getItem('kt-auth-react-v')!)
      const config = {
        headers: {
          Authorization: 'Bearer ' + token.api_token,
        },
      };
      const payload = { booking_id: parseInt(id), remark };
      const res = await axios.post(`${URL.API_BASE_URL}${URL.updateBookingRemark}`, payload, config)
      if (res?.data?.data) {
        toast.success(res?.data?.message);
      };
    } catch (error: any) {
      toast.error(error?.response?.data?.message)
    };
  };

  // 🔴 ADDED: Fit map bounds
  const fitBounds = (map: any) => {
    const bounds = new window.google.maps.LatLngBounds()

    gpsHistory.forEach((p) =>
      bounds.extend({ lat: p.lat, lng: p.lng })
    )

    if (startPoint) bounds.extend(startPoint)
    if (endPoint) bounds.extend(endPoint)

    map.fitBounds(bounds)
  };

  return (
    <div>
      <div className='d-flex flex-column flex-wrap justify-content-center me-3 page-title'>
        <h1 className='d-flex flex-column justify-content-center my-0 fw-bold text-dark page-heading fs-3'>
          View Detail Trip
        </h1>

        <ul className='my-0 breadcrumb-separatorless pt-1 fw-semibold breadcrumb fs-7'>
          <li className='breadcrumb-item text-muted'>
            <Link to={'/'} className='text-hover-primary text-muted'>
              Home
            </Link>
          </li>

          <li className='breadcrumb-item'>
            <span className='bg-gray-400 w-5px h-2px bullet'></span>
          </li>

          <li className='breadcrumb-item text-muted'>View Detail Trip</li>
        </ul>
      </div>

      {/* 🔴 GPS HISTORY BUTTON */}
      <div className='mt-4 mb-4 d-flex justify-content-end'>
        <button
          className='btn btn-danger'
          onClick={() => setShowMap(!showMap)}
        >
          {showMap ? 'Hide GPS History' : 'View GPS History'}
        </button>
      </div>

      {/* 🔴 GPS MAP SECTION */}
      {showMap && (
        <div className='mb-5 card card-flush p-4'>
          <h4 className='fw-bold mb-3'>Trip GPS History</h4>

          {!isLoaded ? (
            <div>Loading map…</div>
          ) : gpsHistory.length === 0 ? (
            <div>No GPS history found</div>
          ) : (
            <GoogleMap
              mapContainerStyle={mapContainerStyle}
              onLoad={fitBounds}
            >
              {/* 🟢 START POINT */}
              {startPoint && (
                <OverlayView
                  position={startPoint}
                  mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                  <div
                    style={{
                      transform: 'translate(-50%, -50%)',
                      width: 36,
                      height: 36,
                      background: '#2563eb',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                      fontSize: 10,
                      fontWeight: 'bold',
                      boxShadow: '0 6px 14px rgba(0,0,0,0.4)',
                      border: '2px solid #fff',
                      pointerEvents: 'none',
                    }}
                  >
                    SOURCE
                  </div>
                </OverlayView>
              )}
              {/* 🔴 END POINT */}
              {endPoint && (
                <OverlayView
                  position={endPoint}
                  mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                  <div
                    style={{
                      transform: 'translate(-50%, -50%)',
                      width: 36,
                      height: 36,
                      background: '#dc2626',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                      fontSize: 10,
                      fontWeight: 'bold',
                      boxShadow: '0 6px 14px rgba(0,0,0,0.4)',
                      border: '2px solid #fff',
                      pointerEvents: 'none',
                    }}
                  >
                    DROP
                  </div>
                </OverlayView>
              )}


              {/* 🚚 GPS HISTORY POINTS */}
              {gpsHistory.map((point, index) => (
                <OverlayView
                  key={index}
                  position={{ lat: point.lat, lng: point.lng }}
                  mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                  <div
                    style={{
                      transform: 'translate(-50%, -100%)',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      pointerEvents: 'none',
                    }}
                  >
                    <div
                      style={{
                        background: 'rgba(17, 24, 39, 0.45)',
                        backdropFilter: 'blur(6px)',
                        border: '1px solid rgba(255,255,255,0.2)',
                        color: '#fff',
                        padding: '6px 10px',
                        borderRadius: 10,
                        fontSize: 12,
                        boxShadow: '0 6px 14px rgba(0,0,0,0.35)',
                        marginBottom: 6,
                        textAlign: 'center',
                      }}
                    >
                      <div>{point.timeString}</div>
                      {/* <div style={{ color: '#fecaca' }}>
                        🚚 {point.speed} km/h
                      </div> */}
                    </div>

                    <div
                      style={{
                        width: 34,
                        height: 34,
                        background: '#16a34a',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        fontSize: 18,
                        boxShadow: '0 6px 14px rgba(0,0,0,0.4)',
                        border: '2px solid #fff',
                      }}
                    >
                      🚚
                    </div>
                  </div>
                </OverlayView>
              ))}
            </GoogleMap>
          )}
        </div>
      )}
      <div className='mt-5 p-6 rounded card card-flush'>
        <div className='mt-9'>
          <table className='table' style={{ fontSize: '12px', fontWeight: '300' }}>
            <tbody>
              <tr>
                <th>Trip ID / Trip Auto ID</th>
                <td>{reportData?.id}</td>
              </tr>
              <tr>
                <th>Customer Name</th>
                <td>{reportData?.user?.name}</td>
              </tr>
              <tr>
                <th>Customer Mobile Number</th>
                <td>{reportData?.user?.mobile}</td>
              </tr>
              <tr>
                <th>Source Address</th>
                <td>{reportData?.source_hydrant_center?.address}</td>
              </tr>
              <tr>
                <th>Destination Address</th>
                <td>{reportData?.destination?.address}</td>
              </tr>
              <tr>
                <th>Trip Accepted By</th>
                <td>{reportData?.driver?.name}</td>
              </tr>
              <tr>
                <th>Trip Accepted At</th>
                <td>{reportData?.accepted_time}</td>
              </tr>
              <tr>
                <th>Trip End</th>
                <td>{reportData?.complete_time}</td>
              </tr>
              <tr>
                <th>Trip Duration</th>
                <td>{reportData?.trip_duration}</td>
              </tr>
              <tr>
                <th>Vehicle</th>
                <td>{reportData?.vehicle?.registration_number}</td>
              </tr>
              <tr>
                <th>Filling Image</th>
                <td>
                  <img src={`${URL.API_BASE_URL}${reportData?.filling_image}`} alt='tripimg' />
                </td>
              </tr>
              <tr>
                <th>Trip Start Image</th>
                <td>
                  <img src={`${URL.API_BASE_URL}${reportData?.destination_image}`} alt='tripimg' />
                </td>
              </tr>
              <tr>
                <th>Before Water Supply</th>
                <td>
                  {' '}
                  <a
                    href={`${URL.API_BASE_URL}${reportData?.filling_video}`}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    -View Video
                  </a>
                </td>
              </tr>
              <tr>
                <th>After Water Supply</th>
                <td>
                  <a
                    href={`${URL.API_BASE_URL}${reportData?.destination_video}`}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    -View Video
                  </a>
                </td>
              </tr>
              <tr>
                <th>Remark</th>
                <td>
                  <div className="d-flex align-items-stretch justify-content-between gap-3">
                    <textarea
                      className="form-control w-75"
                      style={{ height: "50px", resize: "none" }}
                      placeholder="Enter remark"
                      value={remark}
                      onChange={(e: any) => setRemark(e.target.value)}
                    />
                    <button
                      className="btn-outline-secondary w-25 btn btn-primary btn"
                      // style={{ height: "38px" }}
                      onClick={() => {

                        handleRemarkSubmit(id, remark);
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default ViewDetails






